export const MONDIALI_AUTH_ERROR_MESSAGE = 'Sessione non valida. Effettua di nuovo l’accesso e riprova.';
export const MONDIALI_USERNAME_CONFLICT_MESSAGE = 'Questo nome utente è già in uso.';
export const MONDIALI_BANNED_ERROR_MESSAGE = 'Questo account non può registrarsi ai Mondiali.';

export const normalizeMondialiUsername = (username = '') => username.trim().toLowerCase();

export const getMondialiUsernameValidationError = (rawUsername = '') => {
  const normalizedUsername = rawUsername.trim();
  if (normalizedUsername.length < 8 || normalizedUsername.length > 16) {
    return 'Il nome utente deve contenere da 8 a 16 caratteri.';
  }
  if (!/^[a-z0-9]+$/.test(normalizedUsername)) {
    return 'Usa solo lettere minuscole e numeri.';
  }
  return '';
};

export const isMondialiUsernameConflictError = (submissionError) => {
  const statusCode = submissionError?.response?.status;
  const detail = submissionError?.response?.data?.detail;
  const detailText = typeof detail === 'string' ? detail.toLowerCase() : '';

  if (statusCode !== 409) {
    return false;
  }

  return detailText.includes('username') && (detailText.includes('already') || detailText.includes('in use'));
};

export const isMondialiRegistrationBannedError = (submissionError) => {
  const statusCode = submissionError?.response?.status;
  const detail = submissionError?.response?.data?.detail;
  const detailText = typeof detail === 'string' ? detail.toLowerCase() : '';

  if (statusCode !== 403) {
    return false;
  }

  return detailText.includes('cannot register for mondiali') || detailText.includes('banned');
};

export const getFriendlyMondialiRequestError = (
  submissionError,
  {
    fallbackMessage,
    notFoundMessage = fallbackMessage,
  },
) => {
  const statusCode = submissionError?.response?.status;
  const detail = submissionError?.response?.data?.detail;
  const detailText = typeof detail === 'string' ? detail : '';

  if (statusCode === 401 || detailText.toLowerCase() === 'authentication required') {
    return MONDIALI_AUTH_ERROR_MESSAGE;
  }
  if (isMondialiRegistrationBannedError(submissionError)) {
    return MONDIALI_BANNED_ERROR_MESSAGE;
  }
  if (statusCode === 404) {
    return notFoundMessage;
  }
  return fallbackMessage;
};
